import React from 'react';
import PropTypes from 'prop-types';
import ExportModalContentOptions from './ExportModalContentOptions';
import ExportModalContentDisclaimer from './ExportModalContentDisclaimer';
import ExportModalContentFormats from './ExportModalContentFormats';
import ExportModalContentExports from './ExportModalContentExports';
import ExportModalContentRange from './ExportModalContentRange';

function ExportModalContent(props) {
  const { data } = props;
  return (
    <div className="exportModal__content">
      <ExportModalContentFormats {...props} />
      <ExportModalContentRange {...props} />
      <ExportModalContentExports {...props} />
      <ExportModalContentOptions {...props} />
      <ExportModalContentDisclaimer data={data} />
    </div>
  );
}

ExportModalContent.propTypes = {
  data: PropTypes.object,
};

export default ExportModalContent;
